import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';

export enum NTAKTaxCategory {
  A_5 = 'A_5',
  B_18 = 'B_18',
  C_27 = 'C_27',
  D_AJT = 'D_AJT',
  E_0 = 'E_0',
}

export enum NTAKAgeGroup {
  Child = 'GYEREK', // 0-6
  Student = 'DIAK', // 7-25
  Adult = 'FELNOTT', // 26-63
  Pensioner = 'NYUGDIJAS', // 64-69
  Old = 'IDOS', // 70-
  Mixed = 'VEGYES', // 0-99
}

export class NTAKTicketSettings extends DataModel {
  static readonly TYPE_ID: string = '06e2020bde474dad8fb18fd4ca0d0441';

  private constructor(
    public readonly taxCategory: NTAKTaxCategory,
    public readonly ageGroup: NTAKAgeGroup,
  ) {
    super();
  }

  get $typeId(): string {
    return NTAKTicketSettings.TYPE_ID;
  }

  static create(args: {
    taxCategory: NTAKTaxCategory,
    ageGroup: NTAKAgeGroup,
  }): NTAKTicketSettings {
    return new NTAKTicketSettings(
        args.taxCategory,
        args.ageGroup,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): NTAKTicketSettings {
    return new NTAKTicketSettings(
        toEnumFromString(MapUtils.get<string>(map, 'taxCategory'), NTAKTaxCategory),
        toEnumFromString(MapUtils.get<string>(map, 'ageGroup'), NTAKAgeGroup),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      taxCategory: fromEnumAsString(this.taxCategory),
      ageGroup: fromEnumAsString(this.ageGroup),
    };
  }

  clone(): this {
    return new NTAKTicketSettings(
        this.taxCategory,
        this.ageGroup,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.taxCategory === this.taxCategory &&
        other.ageGroup === this.ageGroup;
  }
}

export class NTAKTicketSettingsBuilder extends DataModelBuilder<NTAKTicketSettings> {
  build(context: SerializationContext, map: SerializedData): NTAKTicketSettings {
    return NTAKTicketSettings.fromMap(context, map);
  }
}
